import { Route } from '@angular/router';
import { RoutingID } from '../../../../sb-routing-enum';
import { SbIcons } from '@ngx-seatback/icons';
import { AdvertiserShareOfVoiceComponent } from '../../../../../pages/statistics/sb-share-of-voice/advertiser-share-of-voice/advertiser-share-of-voice.component';

export const advertiserShareOfVoice: Route = {
  path: 'advertiser-share-of-voice',
  component: AdvertiserShareOfVoiceComponent,
  title: 'nav.reporting.advertiser.shareOfVoice',
  data: {
    breadcrumb: 'nav.reporting.advertiser.shareOfVoice',
    icon: SbIcons.pieChartStake,
    id: RoutingID.advertiserShareOfVoice,
  },
};
